import AnnaAfter from '../../../../assets/images/Campaign/Colour/Anna/anna_after.jpg';
import MackAfter from '../../../../assets/images/Campaign/Colour/Mack/mack_after.jpg';
import DinaAfter from '../../../../assets/images/Campaign/Colour/Dina/dina_after.png';
import PayalAfter from '../../../../assets/images/Campaign/Colour/Payal/payal_after.jpg';
import ActonAfter from '../../../../assets/images/Campaign/Colour/Acton/acton_after.png';
import AleksandraAfter from '../../../../assets/images/Campaign/Colour/Aleksandra/aleksandra_after.png';
import ZiggyAfter from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_after.png';
import SoniaAfter from '../../../../assets/images/Campaign/Colour/Sonia/sonia_after.png';

import { ColourTheme } from '../../../../types/ColourTheme';

export const personaToAfter: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: AnnaAfter,
  [ColourTheme.skyblue]: MackAfter,
  [ColourTheme.pomegranate]: DinaAfter,
  [ColourTheme.orchidpink]: PayalAfter,
  [ColourTheme.greensea]: ActonAfter,
  [ColourTheme.jade]: AleksandraAfter,
  [ColourTheme.carrot]: ZiggyAfter,
  [ColourTheme.sunflower]: SoniaAfter,
  [ColourTheme.default]: AnnaAfter,
};